import React, { useEffect, useState } from "react";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import { tabularReport } from "../../../utils/mainTabs/reports/tabularReport";

const TabularReportPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navLinks, buttons, radio } = tabularReport;
  const [toggleOn, setToggleOn] = useState(false);
  const handleReportNavigation = () => {
    setToggleOn(!toggleOn);
  };
  const { tenantName } = useOutletContext();

  useEffect(() => {
    if (toggleOn) {
      navigate(
        `/${localStorage.getItem(
          "tenantName"
        )}/reports/tabularReport/tabularAdvanceReport`
      );
    } else {
      if (
        location.pathname == "/search/reports/tabularReport/classTabularReport"
      ) {
        navigate(
          `/${localStorage.getItem(
            "tenantName"
          )}/reports/tabularReport/classTabularReport`
        );
      } else {
        navigate(
          `/${localStorage.getItem(
            "tenantName"
          )}/reports/tabularReport/userTabularReport`
        );
      }
    }
  }, [toggleOn]);
  useEffect(() => {
    if (
      location.pathname == "/search/reports/tabularReport/userTabularReport"
    ) {
      setToggleOn(false);
      navigate(
        `/${localStorage.getItem(
          "tenantName"
        )}/reports/tabularReport/userTabularReport`
      );
    }
    if (
      location.pathname == "/search/reports/tabularReport/classTabularReport"
    ) {
      navigate(
        `/${localStorage.getItem(
          "tenantName"
        )}/reports/tabularReport/classTabularReport`
      );
      setToggleOn(false);
    }
  }, [location.pathname]);
  return (
    <div>
      <MainLayout
        toggleOn={toggleOn}
        // setToggleOn={toggleOn}
        // radio={radio(navigate, tenantName)}
        buttons={buttons(navigate, tenantName)}
        handleReportNavigation={handleReportNavigation}
        navLinks={navLinks(navigate, tenantName)}
        isRadioBtn
      >
        <Outlet />
      </MainLayout>
    </div>
  );
};

export default TabularReportPage;
